export { default } from './NewsPagination';
